<template>
  <div class="div_loading" v-loading="loading">
    <div class="top_bc_butn">
      <div @click="back" class="bc_butn">返回</div>
      <el-button class="bc_button" icon="el-icon-bell" @click="remindSign(0 , 2)" v-if="getAccount.length > 0 && contractStatus!= 'overdue'&& contractStatus!= 'user_refuse'"> 全部未签提醒</el-button>
    </div>

    <div class="docDetails">
      <div class="detail_msg">
        <el-table
                :header-cell-style="{background:'#DFF7EC',color:'#199A5F',height: '40px'}"
                header-row-class-name="contacts-header"
                style="width: 100%"
                row-class-name="contact"
                class="contract_join_user"
                :data="contract_join_user"
                stripe
        >
          <el-table-column prop="contractName" align="center" label="文档名称" width="180" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="signStatus" align="center" :label=" signOrder == 'serial'? '签署状态(顺序)':'签署状态(无序)'" width="180">
            <template slot-scope="scope">
            <span :class="contractStatus_one_s[scope.row.signStatus]" >
               {{ scope.row.signStatus |ContractStatusFormat_s }}
            </span>
              <!--            <span :class="contractStatus_one_s[scope.row.signStatus]" v-if="loginAccount == scope.row.userAccount">-->
              <!--               {{ scope.row.signStatus |ContractStatusFormat_s }}-->
              <!--            </span>-->
            </template>
          </el-table-column>
          <el-table-column prop="userName" align="center" label="签署人" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="userAccount" align="center" label="签署人账号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="signDate" align="center" label="签署时间" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="address" align="center" label="签署提醒">
            <template slot-scope="scope">
              <el-button type="text"
                         icon="el-icon-bell"
                         @click="remindSign(scope.row , 1)"
                         v-if="scope.row.signStatus =='wait_for_me' && loginAccount != scope.row.userAccount && contractStatus!= 'overdue'&& contractStatus!= 'user_refuse'">
                签署提醒
              </el-button>
              <p v-else :class="contractStatus_one_s[scope.row.signStatus]">
                {{ scope.row.signStatus |ContractStatusFormat_s }}
              </p>

            </template>
          </el-table-column>
        </el-table>
        <div style="color: #ABABAB;font-size: 14px;padding-left: 20px">
          备注:{{remark}}
        </div>
      </div>

      <div class="detail_msg_m">
        <pdf    class="pdf"
                v-for="i in numPages"
                :key="i"
                :src="pdfUrl"
                @page-loaded="pageLoaded($event)"
                :page="i">
        </pdf>
      </div>


    </div>
  </div>

</template>

<script>
  import pdf from "vue-pdf";
  export default {
    components: { pdf },
    data() {
      return {
        signOrder:'',
        pdfsrc: "", // pdf文件地址
        contract_join_user: [],
        contractId: this.$route.query.id,
        type: this.$route.query.type,
        contractStatus_one:{
          drafts:'drafts',
          wait_for_me:'wait_for_other',
          wait_for_other:'wait_for_other',
          user_refuse:'user_refuse',
          overdue:'overdue',
          recall:'recall',
          completed:'completed',
        },
        contractStatus_one_s:{
          drafts:'drafts',
          wait_for_me:'wait_for_me',
          wait_for_other:'wait_for_me',
          user_refuse:'user_refuse',
          overdue:'overdue',
          recall:'recall',
          completed:'completed',
        },
        pdfUrl: '',
        remark: '',
        numPages:1,
        loading:false,
        activeIndex:0,
        loginAccount:this.$SIF.getLocalStorage("userInfo").loginAccount,
        user:this.$SIF.getLocalStorage("userInfo"),
        getAccount:[],
        contractStatus:this.$route.query.contractStatus,
      };
    },
    created() {
      this.contractId = this.$route.query.id;
      this.contractStatus = this.$route.query.contractStatus;
      // // 有时PDF文件地址会出现跨域的情况,这里最好处理一下
      if(this.$route.query.type == 1){
        this.get_contract_one();
      }else {
        this.get_contract();
      }
      this.loginAccount = this.$SIF.getLocalStorage("userInfo").loginAccount
      this.get_contract_join_user();
    },
    methods: {
      back() {
        this.$router.go(-1); //返回上一层
      },
      pageLoaded(e){
        if(e == 1){
          setTimeout(() =>{
            this.loading =false
          },1000);
        }
      },
      remindSign(i , a){
        // contractId
        if(this.user.authenStatus!=1){
          this.$confirm('账号还没有认证,请先去认证.', '提示', {
            confirmButtonText: '去认证',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({name: this.user.userType==1?'enterpriseAuthe':'personalAuthentication'})
          });
          return
        }
        if(a==1){
          this.data ={
            contractJoinUserId: i.contractJoinUserId
          }
        }else {
          this.data ={
            contractId:this.contractId,
          }
        }
        this.$SIF.httpPost({
          url: this.$SIF._serve.manage + "/function/remind-user-sign-contract",
          data: this.data,
          succFun: res => {
            if(res.code == 10000){
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
          },
          failFun: res =>{
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        });
      },
      //加载pdf
      pdfTask(pdfUrl){
        var self = this
        // var liet = pdfUrl.split("/filePath2")
        // var url = self.$SIF.get_file + liet[1]
        // self.pdfUrl = pdf.createLoadingTask(url)
        self.pdfUrl = pdf.createLoadingTask(pdfUrl)
        self.pdfUrl.then(pdf => {
          self.numPages = pdf.numPages
        }).catch((err) => {
          console.error('pdf加载失败')
        })
      },
      get_contract() {
        this.loading = true
        this.$SIF.httpPost({
          url: this.$SIF._serve.manage + "/query/contract-by-id",
          data: {
            contractId :this.contractId
          },
          succFun: res => {
            this.$SIF.downloadFile({
              params: { id: res.data.pdfFileSaveId },
              succFun: res => {
                this.pdfsrc = res.data.url;
                this.pdfTask(this.pdfsrc)
                this.pdfsrc = pdf.createLoadingTask(res.data.url);
              }
            });
          }
        });
      },
      get_contract_one() {
        this.loading = true
        this.$SIF.downloadFile({
          params: { id: this.contractId },
          succFun: res => {
            this.pdfsrc = res.data.url;
            this.pdfTask(this.pdfsrc)
            this.pdfsrc = pdf.createLoadingTask(res.data.url);

          }
        });
      },
      get_contract_join_user() {
        if(this.$route.query.type == 1){
          this.contractId = this.$route.query.ids
        }
        this.loading = true
        this.$SIF.httpPost({
          url: this.$SIF._serve.manage + "/query/list/group/contract-join-user",
          data: {
            contractId: this.contractId
          },
          succFun: res => {
            this.contract_join_user = res.data.others;
            for(var i =0;i<this.contract_join_user.length;i++){
              if(this.contract_join_user[i].signStatus =='wait_for_me' && this.loginAccount != this.contract_join_user[i].userAccount){
                this.getAccount.push(this.contract_join_user[i])
                // this.signStatus.push(this.contract_join_user[i].signStatus)
              }
            }
          }
        });
        this.$SIF.httpPost({
          url: this.$SIF._serve.contract + "/query/contract",
          data: {
            contractId: this.contractId
          },
          succFun: res => {
            this.signOrder =res.data.signRule
            this.remark =res.data.remark
          }
        });
      },

    }
  };
</script>

<style>
  .docDetails {
    width: 100%;
    height: -webkit-calc(100% - 50px);
    height: -moz-calc(100% - 50px);
    height: calc(100% - 50px);
    overflow-x: hidden;
    overflow-y: auto;
    /*三角箭头的颜色*/
    scrollbar-arrow-color: #0FC87D;
    /*滚动条滑块按钮的颜色*/
    scrollbar-face-color: #cdcdcd;
    /*滚动条整体颜色*/
    scrollbar-highlight-color: #0099dd;
    /*滚动条阴影*/
    scrollbar-shadow-color: #cdcdcd;
    /*滚动条轨道颜色*/
    scrollbar-track-color: #fff;
    /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
    scrollbar-3dlight-color:#0099dd;
    /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
    scrollbar-darkshadow-color: #0099dd;
    /*滚动条基准颜色*/
    scrollbar-base-color: #0099dd;

  }
  .docDetails::-webkit-scrollbar {
    width: 4px;
    /*height: 4px;*/
  }

  .docDetails::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: rgba(0,0,0,0.2);
  }

  .docDetails::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 0;
    background: rgba(0,0,0,0.1);
  }
  .tun_m{
    margin: 0;
    line-height: 40px;
  }
  .detail_msg {
    background-color: #fff;
    padding: 10px 27px;
  }
  .top_bc_butn {
    padding: 10px 27px 0px 27px;
    overflow: hidden;
    background:rgba(245,247,246,1);
    border-radius:3px 3px 0px 0px;
    border:1px solid rgba(233,232,232,1);

  }
  .bc_butn {
    width: 57px;
    height: 24px;
    background: rgba(49, 202, 132, 1);
    border-radius: 3px;
    color: #fff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 10px;
    float: left;
  }
  .bc_button{
    float: right;
    border: 1px solid #30D088;
    color: #30D088;
    padding: 5px ;
  }
  .detail_msg_m{
    padding-top: 20px;
    width: 100%;
    overflow: hidden;
  }
  .detail_msg_m .pdf{
    margin-bottom: 20px;
  }
  .contract_join_user {
    box-shadow:2px 2px 16px 0px rgba(187,187,187,0.14);
  }
  .turn{
    width: 33%;
    float: left;
    text-align: center;
  }
  .turn_lifet{
    padding-left: 30px;
    text-align: left;
  }
  .turn_right{
    padding-right: 30px;
    text-align: right;
  }
  .wait_for_me{
    color: #FFBE60;
  }
  .wait_for_other{
    color: #38B0FB;
  }
  .user_refuse{
    color: #FF6000;
  }
  .overdue{
    color: #CBCBCB;
  }
  .completed{
    color: #30D088;
  }
  .drafts{
    color:#7177F3;
  }
  .div_loading{
    width: 100%;
    height: 100%;
  }
</style>
